<template>
	<div>
		<h2>{{ $t('labels.general.subscriptions') }}</h2>
		<div class="btn-bar">
			<div class="btn-group-navigation">
				<router-link :to="{ name: 'UserProfileSubscriptionsSubscriptions' }">{{ $t('labels.general.subscriptions') }}</router-link>
				<router-link :to="{ name: 'UserProfileSubscriptionsResume' }">{{ $t('labels.general.resume') }}</router-link>
			</div>
			<div class="btn-group-operations">
				<button-icon-text-loading
					v-if="isRoute('UserProfileSubscriptionsSubscriptions')"
					@click.native="$emit('open-modal-add-subscription')"
					icon="plus-w" class="plus btn-add">{{ $t('labels.general.add_subscription') }}</button-icon-text-loading>
			</div>
		</div>
		<router-view/>
	</div>
</template>

<script>
export default {
	methods: {
		isRoute (route) {
			return this.$route.name === route
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/Subscriptions.vue